import React from "react";
import { Input } from "../../../../../../../../../../../../components";
import { FORM_KEYS } from "../../../../../../../../../../constants";
/**
 * @desc Input name for product details form.
 */
export const InputProductName = ({ product }) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: `${product.sku}-form-product-name-error`,
  };

  const inputProps = {
    type: "text",
    id: `${product.sku}-input-product-name`,
    className: "form-control",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "NAME",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.PRODUCT_NAME,
  };

  return <Input {...parentProps} />;
};
